import Tag from '../tag';
export default function PickerTag(props, { slots, attrs }) {
    return <Tag color="blue" {...props} {...attrs} v-slots={slots}/>;
}
